<template>
  <div class="marginator">
    <div class=""> 
      <div v-if="items.length == 0" class="nodata">
        <span class="text-grey" size="50px" color="#808F9C">No followers</span>
      </div>
      
      <transition-group name="list">
        <div class="record-card" v-for="record in items" :key="record.username">
          <trade :record="record"></trade>
        </div>
      </transition-group>
    </div>
    <div class="results-card">
      <div class="result-card">
        <div class="result-pl">
          Followers Total P/L:
          <span
            class="bold size-mid"
            v-bind:class="openPl > 0 ? 'profit' : 'loss'"
          >$ {{openPl.toFixed(2)}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import trade from "./item.vue";
import axios from "axios";

export default {
  name: "OpenTrades",
  components: {
    trade
  },
  data() {
    return {
      items: [],
      loaded: false,
      openPl: 0,
      tempName: this.$route.params.name
    };
  },
 watch: {
    "$route.params.name"(val) {
      this.tempName = val;
      if (!this.$route.params.name) {
      this.tempName = this.username;
    }
    this.getHistory();
    }
  },
computed: {
    ...mapGetters(["timezone", "username"])
  },
  mounted() {
    if (!this.$route.params.name) {
      this.tempName = this.username;
    }
    this.getHistory();
  },
  methods: {
    getHistory() {
      this.$emit("loading", true);
      axios
        .post("https://tradeinpool.com:3001/api/request/results/", {
          method: "followers",
          user: this.tempName
        })
        .then(response => {
          this.items = response.data._followers;
          this.loaded = true;
          this.$emit("loading", false);
          this.statCalculate()
        });
    },
    statCalculate() {
      this.openPl = 0;
      this.items.forEach(trade => {
        this.openPl += trade.stats.result;
      });
    }
  },
  sockets: {
    
  }
};
</script>

<style scoped>
.nodata{
  text-align: center;
  width: 100%;
  float: left;
  padding-top: 10px;
  min-height: 50px;
}


.list-enter-active,
.list-leave-active,
.list-move {
  transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
  transition-property: opacity, transform;
}

.list-enter {
  opacity: 0;
  transform: translateX(50px) scaleY(0.5);
}

.list-enter-to {
  opacity: 1;
  transform: translateX(0) scaleY(1);
}

.list-leave-active {
  position: absolute;
}

.list-leave-to {
  opacity: 0;
  transform: scaleY(0);
  transform-origin: center top;
}

.header {
  width: 100%;
}
.datetime {
  color: white;
  font-family: "Roboto", "Roboto Condensed", sans-serif;
  font-weight: bold;
  font-size: 16px;
  margin: 15px;
}

.postInput input[type="text"] {
  margin-right: 15px;
  height: 40px;
  width: 100%;
  border-radius: 20px;
  border: 0px;
  padding-left: 21px;
  background-color: #333b47 !important;
  color: white;
  font-size: 12px;
}

input[type="text"]::placeholder {
  /* Firefox, Chrome, Opera */
  color: white;
}

input[type="text"]:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: white;
}

input[type="text"]::-ms-input-placeholder {
  /* Microsoft Edge */
  color: white;
}
</style>
